import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "7",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m5.844 6.267-4.5 5a.465.465 0 0 1-.688.031.465.465 0 0 1-.031-.687l4.188-4.688L.625 1.267A.465.465 0 0 1 .656.579a.465.465 0 0 1 .688.032l4.5 4.968c.187.22.187.5 0 .688"
    }, null, -1)
  ]))]))
}
export default { render: render }